import React from "react";
import { injectIntl } from "react-intl";
import ExpenseCalculator from "../../../../components/ExpenseCalculatorDialog/ExpenseCalculator/ExpenseCalculator";
import ColoredLeftBorderCard from "../ColoredLeftBorderCard/ColoredLeftBorderCard";
import { Button, Grid, Typography } from "@mui/material";
import { decimalToString } from "../../../../utils/formatNumber";
import { getExpensesTotal } from "../../../../utils/client";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { formatEditFieldLabel } from "../utils";

const ButtonStyle = {
  // position: 'absolute',
  // top: 8,
  // right: 8,
  minWidth: "unset",
  padding: "2px 6px"
};

const EditIconStyle = {
  fontSize: "1.3rem"
};

const TotalValueTypoStyle = {
  fontSize: "2.07rem",
  fontWeight: "bold"
};

const ExpenseCalculatorCard = props => {
  const {
    intl,
    clientId,
    factsheetId,
    expenses,
    onSubmitExpenses,
    toggleDialog,
    template,
    disabled
  } = props;

  const total = getExpensesTotal(expenses);

  const openDialog = () => {
    toggleDialog("expenseCalculator", {
      clientId: clientId,
      factsheetId: factsheetId,
      expenses: expenses,
      onSubmit: onSubmitExpenses
    });
  };

  const editButtonDisabled = disabled;
  const canEdit = !template && !editButtonDisabled;
  const totalEditLabel = formatEditFieldLabel(
    intl,
    intl.formatMessage({ id: "ec-total-expense" })
  );
  const detailsEditLabel = formatEditFieldLabel(
    intl,
    intl.formatMessage({ id: "expense-dialog-title" })
  );

  const handleOpenDialogKeyDown = event => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      openDialog();
    }
  };

  return (
    <ColoredLeftBorderCard
      color="#3966f8"
      contentStyle={{ width: "100%", padding: 16 }}
      style={{ position: "relative" }}
    >
      <Grid container spacing={1}>
        <Grid size={12}>
          <Grid
            container
            spacing={1}
            sx={{
              justifyContent: "flex-start",
              alignItems: "center"
            }}
          >
            <Grid
              container
              spacing={1}
              sx={{
                alignItems: "center",
                cursor: canEdit ? "pointer" : undefined
              }}
              onClick={canEdit ? openDialog : undefined}
              onKeyDown={canEdit ? handleOpenDialogKeyDown : undefined}
              role={canEdit ? "button" : undefined}
              tabIndex={canEdit ? 0 : undefined}
              aria-label={canEdit ? totalEditLabel : undefined}
            >
              <Grid>
                <Typography>
                  {intl.formatMessage({ id: "ec-total-expense" })}
                </Typography>
              </Grid>
              <Grid>
                <Typography color="primary" style={TotalValueTypoStyle}>
                  {decimalToString(total)}
                </Typography>
              </Grid>
            </Grid>
            {!template && (
              <Grid style={{ marginLeft: 8 }}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    ...ButtonStyle,
                    background: !editButtonDisabled
                      ? "var(--new-theme)"
                      : undefined
                  }}
                  onClick={openDialog}
                  disabled={editButtonDisabled}
                  aria-label={detailsEditLabel}
                >
                  <EditRoundedIcon style={EditIconStyle} />
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid
          size={12}
          sx={{ cursor: canEdit ? "pointer" : undefined }}
          onClick={canEdit ? openDialog : undefined}
          onKeyDown={canEdit ? handleOpenDialogKeyDown : undefined}
          role={canEdit ? "button" : undefined}
          tabIndex={canEdit ? 0 : undefined}
          aria-label={canEdit ? detailsEditLabel : undefined}
        >
          <div style={canEdit ? { pointerEvents: "none" } : undefined}>
            <ExpenseCalculator expenses={expenses} layout="row" shrink={true} />
          </div>
        </Grid>
      </Grid>
    </ColoredLeftBorderCard>
  );
};

export default injectIntl(ExpenseCalculatorCard);
